<template>
    <transition-root as="template" :show="show">
        <dialog-headless
            as="div"
            class="fixed z-10 inset-0 overflow-y-auto"
            @close="closeModal()"
        >
            <div
                class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
                <transition-child
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <dialog-overlay
                        class="fixed inset-0 bg-gray-600/75 transition-opacity"
                    />
                </transition-child>

                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <transition-child
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="relative z-10 inline-block align-bottom bg-white dark:bg-gray-700 rounded-lg px-4 pt-3 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
                    >
                        <form @submit.prevent="submitForm()">
                            <div class="sm:items-start">
                                <div class="text-center sm:text-left">
                                    <dialog-title
                                        as="h3"
                                        class="text-lg leading-6 font-medium dark:text-white border-b border-gray-600 mb-4 pb-2"
                                    >
                                        Importar Cupons em Lote
                                    </dialog-title>
                                    <div>
                                        <div class="mt-2">
                                            <label
                                                for="offers"
                                                class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                >Ofertas *</label
                                            >
                                            <div
                                                v-if="loadingOffers"
                                                class="text-sm text-gray-500 dark:text-gray-400"
                                            >
                                                Carregando ofertas...
                                            </div>
                                            <div
                                                v-else
                                                class="max-h-40 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg p-2 bg-gray-50 dark:bg-gray-800"
                                            >
                                                <label
                                                    v-for="offer in offers"
                                                    :key="offer.id"
                                                    class="flex items-center mb-2 cursor-pointer"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :value="offer.id"
                                                        v-model="form.offers"
                                                        class="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                    />
                                                    <span class="ml-2 text-sm text-gray-900 dark:text-gray-300">
                                                        {{ offer.name }} ({{ offer.code }}) - {{ $root.formatCurrency(offer.price) }}
                                                    </span>
                                                </label>
                                                <p
                                                    v-if="offers.length === 0"
                                                    class="text-sm text-gray-500 dark:text-gray-400"
                                                >
                                                    Nenhuma oferta disponível para este produto.
                                                </p>
                                            </div>
                                        </div>

                                        <div class="mt-2">
                                            <label
                                                for="discount_type"
                                                class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                >Tipo de Desconto *</label
                                            >
                                            <select
                                                id="discount_type"
                                                v-model="form.discount_type"
                                                required
                                                class="block p-2 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            >
                                                <option value="">Selecione...</option>
                                                <option value="percentual">Percentual</option>
                                                <option value="fixed">Fixo</option>
                                            </select>
                                        </div>

                                        <div class="mt-2">
                                            <label
                                                for="discount"
                                                class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                            >
                                                Desconto *
                                                <span v-if="form.discount_type === 'percentual'">(%)</span>
                                                <span v-else>(R$)</span>
                                            </label>
                                            <money-input
                                                v-if="form.discount_type === 'fixed'"
                                                v-model="form.discount"
                                                name="discount"
                                            />
                                            <input
                                                v-else
                                                type="number"
                                                id="discount"
                                                v-model="form.discount"
                                                required
                                                min="0"
                                                max="100"
                                                step="1"
                                                placeholder="Ex: 10"
                                                class="block p-2 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            />
                                        </div>

                                        <div class="mt-2 grid grid-cols-2 gap-4">
                                            <div>
                                                <label
                                                    for="starts_at"
                                                    class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                    >Data de Início</label
                                                >
                                                <input
                                                    type="datetime-local"
                                                    id="starts_at"
                                                    v-model="form.starts_at"
                                                    class="block p-2 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                />
                                            </div>

                                            <div>
                                                <label
                                                    for="expires_at"
                                                    class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                    >Data de Expiração</label
                                                >
                                                <input
                                                    type="datetime-local"
                                                    id="expires_at"
                                                    v-model="form.expires_at"
                                                    class="block p-2 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                />
                                            </div>
                                        </div>

                                        <div class="mt-2">
                                            <label
                                                for="usage_limit"
                                                class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                >Limite de Uso</label
                                            >
                                            <input
                                                type="number"
                                                id="usage_limit"
                                                v-model="form.usage_limit"
                                                min="1"
                                                max="1"
                                                placeholder="1"
                                                class="block p-2 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            />
                                            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                                                Máximo: 1 uso por cupom
                                            </p>
                                        </div>

                                        <div class="mt-2">
                                            <label
                                                for="source_file"
                                                class="block mb-2 text-xs font-medium text-gray-900 dark:text-gray-300"
                                                >Arquivo CSV * (contendo apenas uma coluna com os nomes/emails únicos)</label
                                            >
                                            <file-pond
                                                name="source_file"
                                                ref="pond"
                                                class-name="my-pond mt-1 block w-full"
                                                label-idle="Arraste ou clique para adicionar arquivo CSV..."
                                                :allow-multiple="false"
                                                accepted-file-types="text/csv,.csv"
                                                :server="{
                                                    process: (
                                                        fieldName,
                                                        file,
                                                        metadata,
                                                        load,
                                                        error,
                                                        progress,
                                                        abort,
                                                    ) =>
                                                        uploadFile(
                                                            fieldName,
                                                            file,
                                                            metadata,
                                                            load,
                                                            error,
                                                            progress,
                                                            abort,
                                                        ),
                                                }"
                                            />
                                            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                                                Formatos aceitos: CSV
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"
                            >
                                <button
                                    type="submit"
                                    :disabled="loading || form.offers.length === 0"
                                    :class="{ 'cursor-not-allowed opacity-50': loading || form.offers.length === 0 }"
                                    class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <svg
                                        v-if="loading"
                                        class="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        ></circle>
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    {{ loading ? 'Importando...' : 'Importar' }}
                                </button>

                                <button
                                    type="button"
                                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm dark:bg-gray-600 dark:text-white dark:hover:bg-gray-700"
                                    @click="closeModal()"
                                    :disabled="loading"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </transition-child>
            </div>
        </dialog-headless>
    </transition-root>
</template>

<script>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
import { useToast } from "vue-toastification";
import MoneyInput from "../../../../components/forms/MoneyInput.vue";

const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        DialogHeadless: Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        FilePond,
        MoneyInput,
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            loading: false,
            loadingOffers: false,
            offers: [],
            form: {
                offers: [],
                discount_type: 'percentual',
                discount: null,
                starts_at: '',
                expires_at: '',
                usage_limit: null,
                source_file_url: null,
            },
        };
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.fetchOffers();
                this.resetForm();
            }
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        resetForm() {
            this.form = {
                offers: [],
                discount_type: 'percentual',
                discount: null,
                starts_at: '',
                expires_at: '',
                usage_limit: null,
                source_file_url: null,
            };
            if (this.$refs.pond) {
                this.$refs.pond.removeFiles();
            }
        },
        async store(file, options = null) {
            const response = await axios.post(
                "/vapor/signed-storage-url",
                {
                    bucket: options.bucket || "",
                    content_type: options.contentType || file.type,
                    expires: options.expires || "",
                    visibility: "public-read",
                    ...options.data,
                },
                {
                    ...options.options,
                },
            );

            if (response.status !== 200 && response.status !== 201) {
                throw new Error("Erro ao fazer upload.");
            }

            let headers = response.data.headers;

            if ("Host" in headers) {
                delete headers.Host;
            }

            if (typeof options.progress === "undefined") {
                options.progress = () => {};
            }

            const cancelToken = options.cancelToken || "";

            await axios.put(response.data.url, file, {
                cancelToken: cancelToken,
                headers: headers,
                withCredentials: false,
                onUploadProgress: (progressEvent) => {
                    options.progress(
                        progressEvent.loaded / progressEvent.total,
                    );
                },
            });

            response.data.extension = file.name.split(".").pop();

            return response.data;
        },
        uploadFile(
            fieldName,
            file,
            metadata,
            load,
            error,
            filePondProgress,
            abort,
        ) {
            // Validar tipo de arquivo
            const allowedTypes = ['text/csv', 'application/csv', 'text/plain'];
            const allowedExtensions = ['.csv'];
            const fileName = file.name.toLowerCase();
            const fileExtension = fileName.substring(fileName.lastIndexOf('.'));

            const isValidType = allowedTypes.includes(file.type) ||
                               allowedExtensions.includes(fileExtension);

            if (!isValidType) {
                this.toast.error('Tipo de arquivo inválido. Use CSV.');
                abort();
                this.form.source_file_url = null;
                return;
            }

            this.store(file, {
                progress: async (progressValue) => {
                    filePondProgress(Math.round(progressValue * 100));
                },
                abort,
            })
                .then((response) => {
                    load(response);
                    this.form.source_file_url = response?.key;
                })
                .catch((err) => {
                    console.error("Erro ao fazer upload do arquivo:", err);
                    error("Erro ao fazer upload do arquivo");
                    abort();
                    this.form.source_file_url = null;
                });

            return {
                abort: () => {
                    abort();
                    this.form.source_file_url = null;
                },
            };
        },
        fetchOffers() {
            this.loadingOffers = true;
            axios
                .get('/api/product/' + this.product.id + '/offer')
                .then(({ data }) => {
                    this.offers = data.data || [];
                    this.loadingOffers = false;
                })
                .catch((error) => {
                    console.error('Erro ao buscar ofertas:', error);
                    this.toast.error('Erro ao carregar ofertas do produto');
                    this.loadingOffers = false;
                });
        },
        submitForm() {
            if (this.form.offers.length === 0) {
                this.toast.error('Selecione pelo menos uma oferta');
                return;
            }

            if (!this.form.source_file_url) {
                this.toast.error('Selecione um arquivo para importação');
                return;
            }

            this.loading = true;

            const payload = {
                offers: this.form.offers,
                discount_type: this.form.discount_type,
                discount: this.form.discount,
                source_file: this.form.source_file_url,
            };

            if (this.form.starts_at) {
                // Converter datetime-local para formato aceito pelo Laravel (Y-m-d H:i:s)
                const startsAt = new Date(this.form.starts_at);
                payload.starts_at = startsAt.toISOString().slice(0, 19).replace('T', ' ');
            }

            if (this.form.expires_at) {
                // Converter datetime-local para formato aceito pelo Laravel (Y-m-d H:i:s)
                const expiresAt = new Date(this.form.expires_at);
                payload.expires_at = expiresAt.toISOString().slice(0, 19).replace('T', ' ');
            }

            if (this.form.usage_limit) {
                payload.usage_limit = this.form.usage_limit;
            }

            axios
                .post(
                    '/api/product/' + this.product.id + '/coupon/batch-generate',
                    payload
                )
                .then(({ data }) => {
                    this.toast.success('Importação de cupons iniciada com sucesso!');
                    this.closeModal();
                    this.$emit('imported');
                })
                .catch(({ response }) => {
                    if (response?.data?.errors) {
                        const errors = response.data.errors;
                        const firstError = Object.values(errors)[0];
                        this.toast.error(
                            Array.isArray(firstError) ? firstError[0] : firstError
                        );
                    } else if (response?.data?.message) {
                        this.toast.error(response.data.message);
                    } else {
                        this.toast.error('Erro ao importar cupons. Tente novamente.');
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

